import(/* webpackMode: "eager" */ "/vercel/path0/app/programas/[tecnico]/page.tsx");
